const LIST_THEME_OPTION = {
  themeColorOptions: [
    {
      key: 'blue',
      value: {
        sideNav: 'blue',
        mainNav: 'blue',
        sideMenu: 'white'
      },
      rgba: '(33, 150, 243, 0.1)'
    },
    {
      key: 'lightBlue',
      value: {
        sideNav: 'light-blue',
        mainNav: 'light-blue',
        sideMenu: 'white'
      },
      rgba: '(3, 169, 244, 0.1)'
    },
    {
      key: 'teal',
      value: {
        sideNav: 'teal',
        mainNav: 'teal',
        sideMenu: 'white'
      },
      rgba: '(0, 150, 136, 0.1)'
    },
    // {
    //   key: 'red',
    //   value: {
    //     sideNav: 'red',
    //     mainNav: 'red',
    //     sideMenu: 'white'
    //   },
    //   rgba: '(240, 67, 54, 0.1)'
    // },
    {
      key: 'orange',
      value: {
        sideNav: 'orange',
        mainNav: 'orange',
        sideMenu: 'white'
      },
      rgba: '(255, 152, 0, 0.1)'
    },
    {
      key: 'purple',
      value: {
        sideNav: 'purple',
        mainNav: 'purple',
        sideMenu: 'white'
      },
      rgba: '(156, 39, 176, 0.1)'
    },
    {
      key: 'indigo',
      value: {
        sideNav: 'indigo',
        mainNav: 'indigo',
        sideMenu: 'white'
      },
      rgba: '(63, 81, 181, 0.1)'
    },
    {
      key: 'cyan',
      value: {
        sideNav: 'cyan',
        mainNav: 'cyan',
        sideMenu: 'white'
      },
      rgba: '(0, 188, 212, 0.1)'
    },
    // {
    //   key: 'pink',
    //   value: {
    //     sideNav: 'pink',
    //     mainNav: 'pink',
    //     sideMenu: 'white'
    //   },
    //   rgba: '(233, 30, 99, 0.1)'
    // },
    {
      key: 'green',
      value: {
        sideNav: 'green',
        mainNav: 'green',
        sideMenu: 'white'
      },
      rgba: '(76, 175, 80, 0.1)'
    }
  ],

  fontFamilyOptions: [
    { font: 'Montserrat' },
    { font: 'Roboto' },
    { font: 'Calibri' },
    { font: 'Georgia' },
    { font: 'Comic Sans MS' },
    { font: 'Agency FB' }
  ]

}
export { LIST_THEME_OPTION }
